import React, { useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';

import './Header.scss';

import { ReactComponent as Logo } from '../Icons/Header/logo.svg';
import { ReactComponent as Name } from '../Icons/Header/SupportIntel.svg';
import { ReactComponent as Burger } from '../Icons/Header/burger.svg';
import { ReactComponent as Cross } from '../Icons/Header/cross.svg';
// import { RxHamburgerMenu } from "react-icons/rx";
// import { IoMdClose } from "react-icons/io";
import burger from '../Icons/Header/burger.svg';
import cross from '../icons/Header/cross.svg';
import { Link } from 'react-router-dom';

const Header = () => {
	const [nav, setNav] = useState(false);

	const handleNav = () => setNav((prev) => !prev);

	return (
		<div className="header__wrapper">
			<div className="header">
				<Link to="/" className="header__logo">
					<div className="logo__image">
						<Logo />
					</div>
					<div className="logo__name">
						<Name />
					</div>
				</Link>
				<div className="header__nav">
					<ul>
						<ScrollLink to="what" smooth={true} offset={-80} duration={500}>
							<li>Features</li>
						</ScrollLink>
						<ScrollLink to="integrates" smooth={true} offset={-80} duration={500}>
							<li>Connect</li>
						</ScrollLink>
						<ScrollLink to="support" smooth={true} offset={-80} duration={500}>
							<li>Use Cases</li>
						</ScrollLink>
						<ScrollLink to="why" smooth={true} offset={-80} duration={500}>
							<li>Why SupportIntel?</li>
						</ScrollLink>
						<ScrollLink to="solo" smooth={true} offset={-80} duration={500}>
							<li>Plans for Every Team</li>
						</ScrollLink>
						<ScrollLink to="faqs" smooth={true} offset={-80} duration={500}>
							<li>FAQs</li>
						</ScrollLink>
					</ul>
				</div>
				<div className="header__buttons">
					<button
						className="btn"
						onClick={() => window.open('https://platform.supportintel.com/login', '_blank')}>
						Sign in
					</button>
					<button
						className="btn__blue"
						onClick={() => window.open('https://cal.com/globalstaffingsupport/supportintel', '_blank')}
					>
						Free 30-Min Consultation
					</button>
				</div>
				<div className="burger">
					<div onClick={handleNav} className="burger__icon">
						{nav ? <Cross /> : <Burger />}
					</div>
				</div>

				{/* Mobile menu */}

				<div className="mobile__menu">
					<div className={`mobile__menu ${nav ? 'open' : ''}`}>
						<ul>
							<ScrollLink to="what" smooth={true} offset={-80} duration={500}>
								<li onClick={handleNav}>Features</li>
							</ScrollLink>
							<ScrollLink to="integrates" smooth={true} offset={-80} duration={500}>
								<li onClick={handleNav}>Connect</li>
							</ScrollLink>
							<ScrollLink to="support" smooth={true} offset={-80} duration={500}>
								<li onClick={handleNav}>Use Cases</li>
							</ScrollLink>
							<ScrollLink to="why" smooth={true} offset={-80} duration={500}>
								<li onClick={handleNav}>Why SupportIntel?</li>
							</ScrollLink>
							<ScrollLink to="solo" smooth={true} offset={-80} duration={500}>
								<li onClick={handleNav}>Plans for Every Team</li>
							</ScrollLink>
							<ScrollLink to="faqs" smooth={true} offset={-80} duration={500}>
								<li onClick={handleNav}>FAQs</li>
							</ScrollLink>
						</ul>
						<div className="menu__buttons">
							<button
								className="btn"
								onClick={() => window.open('https://platform.supportintel.com/login', '_blank')}>
								Sign in
							</button>
							<button
								className="btn__blue"
								onClick={() => window.open('https://cal.com/globalstaffingsupport/supportintel', '_blank')}
							>
								Free 30-Min Consultation
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Header;
